import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Color } from 'lib/modelBuilder/entities/Color';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { restoreCabinet } from 'containers/Configurator/actions/furniture';
import {
  makeSelectDoorHandleColors,
  makeSelectDoorsKnopItems,
  makeSelectPaintColorHandles,
} from 'containers/HandlesPanel/selectors';
import {
  selectPaintDoorHandleAction,
  updateHandleDoorAction,
} from 'containers/HandlesPanel/actions';
import { DoorHandleType } from 'lib/modelBuilder/constants';
import { useTranslation } from 'react-i18next';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import useMedia from 'use-media';
import { PickerTitleCategory } from '../../components/PickerTitleCategory';
import {
  makeSelectConfiguratorMode,
  makeSelectPaintHandlesMode,
} from '../ModeBar/selectors';
import { ConfiguratorMode, HandlesMode } from '../ModeBar/reducer';
import ItemPicker from '../../helpers/ItemPicker';
import ItemPickerList from '../../components/ItemPickerList';

// import styled from 'styled-components/macro';

interface StateProps {
  colors: Color[];
  lastHistoryCabinet: Cabinet;
  mode: ConfiguratorMode;
  handlesMode: HandlesMode;
  paintColor: Color | undefined;
  knopItems: ItemPicker[];
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  colors: makeSelectDoorHandleColors(),
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
  mode: makeSelectConfiguratorMode(),
  handlesMode: makeSelectPaintHandlesMode(),
  paintColor: makeSelectPaintColorHandles(),
  knopItems: makeSelectDoorsKnopItems(),
});

const CupColorPicker = () => {
  const dispatch = useDispatch();
  const {
    colors,
    lastHistoryCabinet,
    mode,
    handlesMode,
    paintColor,
    knopItems,
  } = useSelector(stateSelector);
  const { t } = useTranslation();
  const isMobile = useMedia({ maxWidth: 1023 });

  const colorSelected = (color: Color, preview: boolean) => {
    dispatch(
      updateHandleDoorAction(DoorHandleType.Knop, color, undefined, preview),
    );
  };

  const onClickColor = (item: ItemPicker) => {
    if (mode === ConfiguratorMode.handles) {
      dispatch(
        selectPaintDoorHandleAction(DoorHandleType.Knop, item.color as Color),
      );
    } else colorSelected(item.color as Color, false);
  };

  const onMouseOverColor = (item: ItemPicker) => {
    if (mode === ConfiguratorMode.selector)
      colorSelected(item.color as Color, true);
  };

  const onLeave = () => {
    // Restore the last history element
    if (mode === ConfiguratorMode.selector)
      dispatch(restoreCabinet(lastHistoryCabinet));
  };

  let activeColor: Color | undefined = undefined;
  if (mode === ConfiguratorMode.handles && handlesMode === HandlesMode.doors) {
    activeColor = paintColor;
  }

  return (
    <div className="mx-2 px-2 px-1">
      {!isMobile && (
        <div className="flex bg-gray-300">
          <PickerTitleCategory selected onClick={() => {}}>
            {t('Knop colors')}
          </PickerTitleCategory>
        </div>
      )}
      {colors && (
        <div onMouseLeave={onLeave}>
          <ItemPickerList
            items={knopItems}
            onClick={onClickColor}
            onDoubleClick={() => {
              if (mode === ConfiguratorMode.selector)
                dispatch(setColorsPanelAction());
            }}
            onMouseOver={onMouseOverColor}
            selectedColor={activeColor}
            medium={true}
          />
        </div>
      )}
    </div>
  );
};

export default CupColorPicker;
